import { CircularProgress } from '@packages/shared/src/ui/CircularProgress/CircularProgress';

import type { JSX } from 'react';

/**
 * This component displays Loader on Service Layer
 * @returns JSX.Element to be placed in Service Layer
 */
export const ServiceLayerLoader = (): JSX.Element => (
  <div className="flex size-full items-center justify-center">
    <CircularProgress mode="indeterminate" className="size-6" />
  </div>
);
